import { inject } from "@angular/core"
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router"
import { AuthFacade } from "auth"
import { filter, map, take } from "rxjs"

export const userResolver: ResolveFn<any> =
(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

  const authFacade = inject(AuthFacade)
  // - Wait for the fully-loaded profile: loadSuccess sets loaded:true WITH csData,
  //   whereas loginSuccess emits an early profile WITHOUT csData. Taking profile$ directly
  //   (take(1)) could grab that early one → empty cs.* selects in the edit form.
  return authFacade.loaded$.pipe(
    filter(loaded => loaded === true),
    take(1),
    map(() => authFacade.profile())
  )
}

    